import { createBrowserBridge } from './browserBridge'
import { detectPlatform } from './detectPlatform'
import { createMaxBridge } from './maxBridge'
import { createTelegramBridge } from './telegramBridge'
import type { MessengerBridge } from './types'

export type { MessengerBridge, MessengerPlatform, ThemeScheme } from './types'

export const createMessengerBridge = (): MessengerBridge => {
  const platform = detectPlatform()

  if (platform === 'telegram') {
    return createTelegramBridge()
  }

  if (platform === 'max') {
    return createMaxBridge()
  }

  return createBrowserBridge()
}
